<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-n3">
        <b>{{
          inputs.language === 'en' ? 'Select the best answer' : 'Sélectionnez la meilleure réponse'
        }}</b
        >.
        {{
          inputs.language === 'en'
            ? 'From among the following options, select the drying agent most used after an extraction process.'
            : "Parmi les options suivantes, sélectionnez l'agent dessiccatif le plus utilisé après une extraction."
        }}
      </p>

      <v-radio-group v-model="inputs.studentAnswer" :disabled="!allowEditing" class="mb-0 pl-6">
        <v-radio
          v-for="option in inputs.language === 'en' ? optionsShuffled : optionsShuffledFr"
          :key="'pt-1-' + option.value"
          class="my-1"
          :value="option.value"
        >
          <template #label>
            <stemble-latex :content="option.text" />
          </template>
        </v-radio>
      </v-radio-group>

      <v-btn-toggle
        v-model="inputs.language"
        class="ml-2"
        size="small"
        dense="dense"
        rounded="rounded"
        mandatory
      >
        <v-btn :value="'en'">English</v-btn>
        <v-btn :value="'fr'">Français</v-btn>
      </v-btn-toggle>
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex.vue';
import {seededShuffle} from '@/courses/utils/seededShuffle';

export default {
  name: 'uOttawa1321Prelab3Q6',
  components: {
    StembleLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    const browserLanguage = navigator.language.split('-')[0]; // Extract the language code
    return {
      inputs: {
        studentAnswer: null,
        language: browserLanguage === 'fr' ? 'fr' : 'en', // Set the initial language based on browser preference
      },
      options: [
        {text: 'Potassium hydroxide', value: 'potassiumHydroxide'},
        {text: 'Sodium chloride', value: 'sodiumChloride'},
        {text: 'Sodium carbonate', value: 'sodiumCarbonate'},
        {text: 'Magnesium bromide', value: 'magnesiumBromide'},
        {text: 'Anhydrous sodium sulfate', value: 'sodiumSulfate'},
      ],
      optionsFr: [
        {text: 'Hydroxyde de potassium', value: 'potassiumHydroxideFr'},
        {text: 'Chlorure de sodium', value: 'sodiumChlorideFr'},
        {text: 'Sulfate de sodium anhydre', value: 'sodiumSulfateFr'},
        {text: 'Carbonate de sodium', value: 'sodiumCarbonateFr'},
        {text: 'Bromure de magnésium', value: 'magnesiumBromideFr'},
      ],
    };
  },
  computed: {
    seed() {
      return this.$inertia.getSeed();
    },
    optionsShuffled() {
      return seededShuffle(this.options, this.seed);
    },
    optionsShuffledFr() {
      return seededShuffle(this.optionsFr, this.seed);
    },
  },
};
</script>
